import { render, staticRenderFns } from "./StepToken.vue?vue&type=template&id=dfc676dc&scoped=true"
import script from "./StepToken.vue?vue&type=script&lang=js"
export * from "./StepToken.vue?vue&type=script&lang=js"
import style0 from "./StepToken.vue?vue&type=style&index=0&id=dfc676dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc676dc",
  null
  
)

export default component.exports